import { render, staticRenderFns } from "./fileinfo.vue?vue&type=template&id=cba14736&scoped=true&"
import script from "./fileinfo.vue?vue&type=script&lang=js&"
export * from "./fileinfo.vue?vue&type=script&lang=js&"
import style0 from "./fileinfo.vue?vue&type=style&index=0&id=cba14736&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba14736",
  null
  
)

export default component.exports